@if (fileSrc) { @if ((file.mimetype | fileType) === 'image') {
<img
  [alt]="file.alt"
  [ngStyle]="{ opacity: opacity, 'min-height': minHeight }"
  [src]="fileSrc"
  nz-image
/>
} @if ((file.mimetype | fileType) === 'pdf') {

<iframe
  class="embed-responsive-item"
  [src]="fileSrc | safeURL"
  [attr.height]="file.height ? file.height : null"
  width="100%"
  [ngStyle]="{
    opacity: opacity,
    'min-height': minHeight ? minHeight + 'px' : null
  }"
></iframe>
} @if ((file.mimetype | fileType) === 'doc') {
<i nz-icon nzType="file-word" nzTheme="outline"></i>
} @if ((file.mimetype | fileType) === 'unknown') {
<i nz-icon nzType="file" nzTheme="outline"></i>
} @if ((file.mimetype | fileType) === 'video') {
<video
  #videoElement
  (click)="videoElement.play()"
  [ngStyle]="{ opacity: opacity, 'min-height': minHeight }"
  controls
>
  <source [src]="fileSrc | safeURL" [type]="file.mimetype" />
  Your browser does not support the video tag.
</video>
} @if (!file.mimetype) {
<img
  alt="Document"
  [ngStyle]="{ 'min-height': 500 }"
  [src]="fileSrc"
  nz-image
/>
} }
